import React from 'react';

/**
 * Compact rank-movement indicator for leaderboard rows.
 *
 * rank_delta convention (from leaderboard_snapshot_entries):
 *   > 0  improved rank (moved up the leaderboard)
 *   < 0  dropped rank
 *   0    no change since previous snapshot
 *   null first snapshot for this player on this ladder ("New")
 *
 * @param {number|null} rankDelta
 * @param {'xs'|'sm'} size
 */
const RankMovementLabel = ({ rankDelta, size = 'xs' }) => {
  const textSize = size === 'xs' ? 'text-xs' : 'text-sm';

  if (rankDelta === null || rankDelta === undefined) {
    return (
      <span className={`${textSize} text-text-muted font-medium`} title="First snapshot for this ladder">
        New
      </span>
    );
  }

  if (rankDelta === 0) {
    return (
      <span className={`${textSize} text-text-muted font-medium`} title="No change since last session">
        —
      </span>
    );
  }

  if (rankDelta > 0) {
    return (
      <span
        className={`${textSize} text-success font-semibold`}
        title={`Improved ${rankDelta} place${rankDelta !== 1 ? 's' : ''} since last session`}
      >
        ▲ {rankDelta}
      </span>
    );
  }

  return (
    <span
      className={`${textSize} text-danger font-semibold`}
      title={`Dropped ${Math.abs(rankDelta)} place${Math.abs(rankDelta) !== 1 ? 's' : ''} since last session`}
    >
      ▼ {Math.abs(rankDelta)}
    </span>
  );
};

export default RankMovementLabel;
